import * as vp from 'vopay';

const useFileDownload = (): {
  downloadJson: (data: unknown, fileName: string) => void;
  downloadPdf: (data: string, fileName: string) => void;
  downloadCsv: (data: string, fileName: string) => void;
  downloadCsvFile: (data: string, fileName: string) => void;
} => {
  const downloadJson = (data: unknown, fileName: string) => {
    vp.downloadBlob({
      data: JSON.stringify(data, null, 4),
      fileName: `${fileName.replace('.json', '')}.json`,
      fileType: 'text/json',
    });
  };

  const downloadPdf = (data: string, fileName: string) => {
    vp.downloadBase64DataUri({
      data,
      fileName: `${fileName.replace('.pdf', '')}.pdf`,
      fileType: 'application/pdf',
    });
  };

  const downloadCsv = (data: string, fileName: string) => {
    vp.downloadBase64DataUri({
      data,
      fileName: `${fileName.replace('.csv', '')}.csv`,
      fileType: 'application/octet-stream',
    });
  };

  const downloadCsvFile = (data: string, fileName: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = data;
    downloadLink.setAttribute('download', `${fileName.replace('.csv', '')}.csv`);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return {
    downloadJson,
    downloadPdf,
    downloadCsv,
    downloadCsvFile,
  };
};

export default useFileDownload;
